// Dynamic technical information field templates.
// Phase 1: frontend-only routing by service type so the edit form shows the
// right fields for Fibra / Móvil / TV / Centralita / Terminal IP / Numeración /
// WiFi / IP fija. Unknown existing keys are preserved and surfaced under
// "Otros datos técnicos" so legacy data is never lost.

// Field descriptor shape:
//   { key, label, type, options?, placeholder? }
// type ∈ 'text' | 'password' | 'textarea' | 'boolean' | 'date' | 'select'

export const TECHNICAL_FIELD_TEMPLATES = {
  fibra: [
    { key: "router_modelo", label: "Router modelo", type: "text" },
    { key: "router_serial", label: "Router serial", type: "text" },
    { key: "mac_router", label: "MAC router", type: "text" },
    { key: "observaciones_tecnicas", label: "Observaciones técnicas", type: "textarea" },
  ],
  movil: [
    { key: "numero_linea", label: "Número de línea / MSISDN", type: "text" },
    { key: "icc_sim", label: "ICC SIM", type: "text" },
    { key: "puk", label: "PUK", type: "password" },
    { key: "pin", label: "PIN", type: "password" },
    { key: "tipo_sim", label: "Tipo SIM", type: "select", options: ["física", "eSIM"] },
    { key: "qr_esim", label: "QR eSIM / código activación", type: "textarea" },
    { key: "apn", label: "APN", type: "text" },
    { key: "portabilidad", label: "Portabilidad", type: "boolean" },
    { key: "operador_donante", label: "Operador donante", type: "text" },
    { key: "fecha_portabilidad", label: "Fecha portabilidad", type: "date" },
    { key: "titular_linea", label: "Titular línea", type: "text" },
    { key: "roaming_activo", label: "Roaming activo", type: "boolean" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  tv: [
    { key: "usuario_tv", label: "Usuario TV / cuenta", type: "text" },
    { key: "password_tv", label: "Contraseña TV", type: "password" },
    { key: "tipo_acceso", label: "Tipo acceso", type: "select", options: ["app", "deco"] },
    { key: "perfil_tv", label: "Perfil TV contratado", type: "text" },
    { key: "pin_parental", label: "PIN parental", type: "password" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  centralita: [
    { key: "numero_extension", label: "Número de extensión", type: "text" },
    { key: "ddi_asociado", label: "DDI asociado", type: "text" },
    { key: "usuario", label: "Usuario", type: "text" },
    { key: "caller_id", label: "Caller ID", type: "text" },
    { key: "buzon_voz", label: "Buzón de voz", type: "boolean" },
    { key: "grupo_salto", label: "Grupo de salto", type: "text" },
    { key: "terminal_asociado", label: "Terminal asociado", type: "text" },
    { key: "mac_terminal", label: "MAC terminal", type: "text" },
    { key: "url_provision", label: "URL provision", type: "text" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  terminal: [
    { key: "modelo", label: "Modelo", type: "text" },
    { key: "numero_serie", label: "Número de serie", type: "text" },
    { key: "mac", label: "MAC", type: "text" },
    { key: "extension_asignada", label: "Extensión asignada", type: "text" },
    { key: "usuario_sip", label: "Usuario SIP", type: "text" },
    { key: "url_provision", label: "URL provisión", type: "text" },
    { key: "firmware", label: "Firmware", type: "text" },
    { key: "password_admin", label: "Contraseña admin", type: "password" },
    { key: "ubicacion_fisica", label: "Ubicación física", type: "text" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  numeracion: [
    { key: "numero", label: "Número", type: "text" },
    { key: "tipo", label: "Tipo", type: "select", options: ["principal", "DDI", "portado"] },
    { key: "operador_donante", label: "Operador donante", type: "text" },
    { key: "fecha_portabilidad", label: "Fecha portabilidad", type: "date" },
    { key: "estado_portabilidad", label: "Estado portabilidad", type: "select", options: ["pendiente", "en curso", "completada", "rechazada"] },
    { key: "destino_enrutamiento", label: "Destino de enrutamiento", type: "text" },
    { key: "caller_id_permitido", label: "Caller ID permitido", type: "boolean" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  wifi: [
    { key: "ap_modelo", label: "AP modelo", type: "text" },
    { key: "ap_serial", label: "AP serial", type: "text" },
    { key: "mac_ap", label: "MAC AP", type: "text" },
    { key: "ubicacion_ap", label: "Ubicación AP", type: "text" },
    { key: "controladora_site", label: "Controladora / site", type: "text" },
    { key: "ssid", label: "SSID", type: "text" },
    { key: "password_ssid", label: "Contraseña SSID", type: "password" },
    { key: "vlan", label: "VLAN", type: "text" },
    { key: "ip_gestion", label: "IP gestión", type: "text" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  ip_fija: [
    { key: "ip_publica", label: "IP pública", type: "text" },
    { key: "mascara_prefijo", label: "Máscara / prefijo", type: "text" },
    { key: "gateway", label: "Gateway", type: "text" },
    { key: "dns_primario", label: "DNS primario", type: "text" },
    { key: "dns_secundario", label: "DNS secundario", type: "text" },
    { key: "bloque_ip", label: "Bloque IP", type: "text" },
    { key: "observaciones", label: "Observaciones", type: "textarea" },
  ],
  // Fallback: single free-text observations area. Legacy fields from the
  // previous hardcoded Fibra form (brand_model / ip_address / router_user /
  // router_password / access_data / technical_contact) are still preserved
  // via the "Otros datos técnicos" section in the UI for backward compat.
  otros: [
    { key: "observaciones_tecnicas", label: "Observaciones técnicas", type: "textarea" },
  ],
};

export const SERVICE_TYPE_LABELS = {
  fibra: "Fibra",
  movil: "Móvil",
  tv: "TV",
  centralita: "Centralita",
  terminal: "Terminal IP",
  numeracion: "Numeración / DDI",
  wifi: "WiFi Pyme",
  ip_fija: "IP fija / direccionamiento",
  otros: "Técnica",
};

// Legacy keys used by the previous single-template UI. They keep appearing on
// older `informacion_tecnica` payloads, so we hide them from "Otros datos
// técnicos" to avoid visual noise (they still remain persisted — merge
// semantics on the backend never delete them).
const LEGACY_KNOWN_KEYS = new Set([
  "brand_model",
  "ip_address",
  "router_user",
  "router_password",
  "access_data",
  "technical_contact",
  "technical_notes",
]);

// Resolve the ServiceCategory record that corresponds to the given customer
// service. Uses the catalog lookup → `categoria` name → ServiceCategory.
function resolveCategoryRecord(service, catalogServices = [], serviceCategories = []) {
  if (!service) return null;
  const catalog = catalogServices.find(c => c.id === service.catalog_service_id) || null;
  const categoriaName = (catalog?.categoria || "").toString();
  if (!categoriaName) return null;
  return (
    serviceCategories.find(
      c => c.name === categoriaName || c.nombre === categoriaName || c.id === categoriaName
    ) || null
  );
}

// Produce the effective template for rendering the technical-info form.
// Priority: category.campos_tecnicos (Catalog-driven, source of truth) →
// frontend default map (backward compatibility / offline fallback).
export function resolveTechnicalTemplate(service, catalogServices = [], serviceCategories = []) {
  const category = resolveCategoryRecord(service, catalogServices, serviceCategories);
  const configured = Array.isArray(category?.campos_tecnicos) ? category.campos_tecnicos : [];
  if (configured.length > 0) {
    // Keep only whitelisted props; coerce unknown types to "text" so a
    // malformed row can't crash the renderer.
    const allowed = new Set(["text", "password", "textarea", "boolean", "date", "select"]);
    return configured
      .filter(f => f && f.key && f.label)
      .map(f => ({
        key: f.key,
        label: f.label,
        type: allowed.has(f.type) ? f.type : "text",
        options: Array.isArray(f.options) ? f.options : undefined,
        sensitive: !!f.sensitive,
        required: !!f.required,
      }));
  }
  // Fallback: existing frontend default map.
  const type = detectServiceType(service, catalogServices, serviceCategories);
  return TECHNICAL_FIELD_TEMPLATES[type] || TECHNICAL_FIELD_TEMPLATES.otros;
}

// Resolve a friendly label for the template badge in the UI.
export function resolveTemplateLabel(service, catalogServices = [], serviceCategories = []) {
  const category = resolveCategoryRecord(service, catalogServices, serviceCategories);
  const configured = Array.isArray(category?.campos_tecnicos) ? category.campos_tecnicos : [];
  if (configured.length > 0) return category?.name || "Categoría";
  const type = detectServiceType(service, catalogServices, serviceCategories);
  return SERVICE_TYPE_LABELS[type] || SERVICE_TYPE_LABELS.otros;
}

// Prefers structured metadata (bloque / categoría) over product-name matching.
export function detectServiceType(service, catalogServices = [], serviceCategories = []) {
  if (!service) return "otros";

  // 1) Look up the catalog entry to pull `categoria` (category name string).
  const catalog = catalogServices.find(c => c.id === service.catalog_service_id) || null;
  const categoriaName = (catalog?.categoria || "").toString();

  // 2) Look up the ServiceCategory record to pull the bloque(s).
  const categoryRecord = serviceCategories.find(
    c => c.name === categoriaName || c.nombre === categoriaName || c.id === categoriaName
  ) || null;
  const bloques = [
    categoryRecord?.bloque_package_builder,
    ...(Array.isArray(categoryRecord?.bloques_package_builder) ? categoryRecord.bloques_package_builder : []),
  ].filter(Boolean).map(b => b.toString().toUpperCase());

  const hasBloque = (b) => bloques.includes(b);

  // 3) Priority: bloque-based mapping (most reliable).
  //    NB: CONVERGENTE is intentionally excluded here — it describes the
  //    package/origin (a convergent bundle), not the service type. Each line
  //    inside a convergent package carries its own specific bloque
  //    (SOLO_FIBRA, MOVILES_PAQ, TV, …) that we match below.
  if (hasBloque("SOLO_FIBRA")) return "fibra";
  if (hasBloque("SOLO_MOVIL") || hasBloque("MOVILES_PAQ") || hasBloque("BONO_MOVIL")) return "movil";
  if (hasBloque("TV") || hasBloque("DESCUENTO_TV")) return "tv";
  if (hasBloque("CENTRALITA") || hasBloque("BONO_CENTRALITA") || hasBloque("DESCUENTO_CENTRALITA")) return "centralita";
  if (hasBloque("TERMINAL")) return "terminal";
  if (hasBloque("NUMERACION")) return "numeracion";
  if (hasBloque("WIFI") || hasBloque("DESCUENTO_WIFI")) return "wifi";
  if (hasBloque("IP_ADICIONAL")) return "ip_fija";

  // 4) Secondary: categoría name (case-insensitive contains).
  const cat = categoriaName.toLowerCase();
  if (cat.includes("fibra") || cat.includes("internet")) return "fibra";
  if (cat.includes("móvil") || cat.includes("movil") || cat.includes("línea móvil")) return "movil";
  if (cat.includes("tv") || cat.includes("televis")) return "tv";
  if (cat.includes("centralita") || cat.includes("ext")) return "centralita";
  if (cat.includes("terminal") || cat.includes("teléfono") || cat.includes("telefono")) return "terminal";
  if (cat.includes("numeración") || cat.includes("numeracion") || cat.includes("ddi")) return "numeracion";
  if (cat.includes("wifi")) return "wifi";
  if (cat.includes("ip") || cat.includes("direccion")) return "ip_fija";

  // 5) Last-resort fallback: service name heuristics.
  const nombre = (service.nombre_servicio || "").toLowerCase();
  if (nombre.includes("fibra") || nombre.includes("ftth")) return "fibra";
  if (nombre.includes("móvil") || nombre.includes("movil") || nombre.includes("sim") || nombre.includes("msisdn")) return "movil";
  if (nombre.includes("tv") || nombre.includes("deco")) return "tv";
  if (nombre.includes("centralita") || nombre.includes("extens")) return "centralita";
  if (nombre.includes("terminal")) return "terminal";
  if (nombre.includes("ddi") || nombre.includes("numerac")) return "numeracion";
  if (nombre.includes("wifi")) return "wifi";
  if (nombre.includes("ip fija") || nombre.includes("ip pública")) return "ip_fija";

  return "otros";
}

// Split incoming informacion_tecnica into:
//   known:   keys covered by the active template (used to render fields)
//   unknown: keys NOT in the template AND NOT legacy known — surfaced under
//            "Otros datos técnicos" so legacy/custom data remains visible.
// Legacy keys (brand_model, ip_address, …) are filtered out of "unknown" to
// keep the UI clean; they still round-trip through the backend merge.
export function splitTechnicalInfoByTemplate(info, template) {
  const safe = info || {};
  const templateKeys = new Set((template || []).map(f => f.key));
  const known = {};
  const unknown = {};
  for (const [k, v] of Object.entries(safe)) {
    if (templateKeys.has(k)) {
      known[k] = v;
    } else if (!LEGACY_KNOWN_KEYS.has(k)) {
      unknown[k] = v;
    }
  }
  return { known, unknown };
}
